import { render } from "./SelectMotor.vue?vue&type=template&id=1ee71664"
import script from "./SelectMotor.vue?vue&type=script&lang=js"
export * from "./SelectMotor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__